import moment from "moment";

export const formatDate = (
  date: string | Date | null | undefined,
  format: string,
  parseDateFormat: string | null = null,
) => {
  if (!date) {
    return null;
  }

  if (parseDateFormat) {
    return moment(date, parseDateFormat).format(format);
  }

  return moment(date).format(format);
};
